
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-retake",
      function () {
        return require("private-next-pages/ai-retake/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-retake"])
      });
    }
  